import template from './notification-setup.html';
import './notification-setup.css';

class NotificationSetupVM
{
	constructor (page)
	{
		this.page = page;
		this.channels = ko.observableArray([]);
		this.notification_groups = ko.observableArray([]);
		this.loading = ko.observable(true);
		this.expanded_type_id = ko.observable(null);
	}

	toggleExpand (notification_type_id)
	{
		if (this.expanded_type_id() === notification_type_id)
			this.expanded_type_id(null);
		else
			this.expanded_type_id(notification_type_id);
	}

	async btnToggleSubscription_click (nt_row, channel)
	{
		const sub_key = `${channel.notification_channel_id}`;
		const existing = nt_row.channel_subs[sub_key];

		if (existing && existing.subscription_id)
		{
			const result = await Grape.fetches.postJSON('/api/notifications/subscription/delete', {
				notification_subscription_id: existing.subscription_id
			});
			if (result.status === 'OK')
			{
				nt_row.channel_subs[sub_key] = { subscribed: ko.observable(false), subscription_id: null };
				existing.subscribed(false);
			}
		}
		else
		{
			const result = await Grape.fetches.postJSON('/api/notifications/subscription', {
				notification_type_id: nt_row.notification_type_id,
				notification_channel_id: channel.notification_channel_id
			});
			if (result.status === 'OK')
			{
				nt_row.channel_subs[sub_key] = {
					subscribed: ko.observable(true),
					subscription_id: result.notification_subscription_id
				};
				existing.subscribed(true);
			}
		}
	}

	async btnAddContextSub_click (nt_row)
	{
		const result = await Grape.dialog.open('EditNotificationSubscription', {
			notification_type: nt_row,
			channels: this.channels()
		});
		if (result)
			await this.page.updateData();
	}

	async btnEditContextSub_click (sub)
	{
		const result = await Grape.dialog.open('EditNotificationSubscription', {
			subscription: sub,
			channels: this.channels()
		});
		if (result)
			await this.page.updateData();
	}

	async btnDeleteContextSub_click (sub)
	{
		if (!(await Grape.alerts.confirm({ type: 'warning', title: 'Confirm', message: 'Delete this subscription?' })))
			return;

		const result = await Grape.fetches.postJSON('/api/notifications/subscription/delete', {
			notification_subscription_id: sub.notification_subscription_id
		});
		if (result.status === 'OK')
			await this.page.updateData();
	}
}

class NotificationSetupPage
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new NotificationSetupVM(this);
	}

	async init ()
	{
		await this.updateData();
	}

	async updateData ()
	{
		this.viewModel.loading(true);

		try
		{
			const [types_res, channels_res, subs_res] = await Promise.all([
				Grape.fetches.getJSON('/api/record', {
					schema: 'notifications',
					table: 'v_notification_type'
				}),
				Grape.fetches.getJSON('/api/record', {
					schema: 'notifications',
					table: 'v_notification_channel'
				}),
				Grape.fetches.getJSON('/api/record', {
					schema: 'notifications',
					table: 'v_notification_subscription'
				})
			]);

			const types = types_res.records || [];
			const channels = channels_res.records || [];
			const subs = subs_res.records || [];

			this.viewModel.channels(channels);

			const subs_by_type = {};
			for (const sub of subs)
			{
				if (!subs_by_type[sub.notification_type_id])
					subs_by_type[sub.notification_type_id] = [];
				subs_by_type[sub.notification_type_id].push(sub);
			}

			const groups_map = {};
			for (const t of types)
			{
				const group = t.notification_group || 'Ungrouped';
				if (!groups_map[group])
					groups_map[group] = [];

				const type_subs = subs_by_type[t.notification_type_id] || [];

				const default_subs = type_subs.filter(s =>
					!s.context_match || JSON.stringify(s.context_match) === '{}'
				);
				const context_subs = type_subs.filter(s =>
					s.context_match && JSON.stringify(s.context_match) !== '{}'
				);

				const channel_subs = {};
				for (const ch of channels)
				{
					const matching = default_subs.find(s =>
						s.notification_channel_id === ch.notification_channel_id
					);
					channel_subs[ch.notification_channel_id] = {
						subscribed: ko.observable(!!matching),
						subscription_id: matching ? matching.notification_subscription_id : null
					};
				}

				groups_map[group].push({
					notification_type_id: t.notification_type_id,
					notification_group: t.notification_group,
					notification_name: t.notification_name,
					context_fields: t.context_fields,
					channel_subs: channel_subs,
					context_subscriptions: ko.observableArray(context_subs),
					has_context_fields: t.context_fields && (
						(Array.isArray(t.context_fields) && t.context_fields.length > 0) ||
						(!Array.isArray(t.context_fields) && Object.keys(t.context_fields).length > 0)
					)
				});
			}

			const groups = [];
			for (const group_name of Object.keys(groups_map).sort())
				groups.push({ name: group_name, types: groups_map[group_name] });

			this.viewModel.notification_groups(groups);
		}
		catch (err)
		{
			Grape.alerts.alert({ type: 'error', title: 'Error', message: err.message });
		}

		this.viewModel.loading(false);
	}
}

export default {
	route: '[/]ui/notifications/setup',
	page_class: NotificationSetupPage,
	template: template
}
